import { Plug } from 'lucide-react';
import { Outlet } from 'react-router-dom';

/**
 * Connect pillar layout (route /connect, formerly /execute; the "Connect"
 * bottom-nav destination).
 *
 * The pillar now leads with one job: connecting an AI to SystemDox. The index
 * (BuildStandardsPage) opens as a two-card chooser — Connect via SystemDox MCP
 * (setup steps plus the live MCP preview) or Connect via Skills (the SKILL.md
 * export) — with the choice carried in ?via=. The workspace standards it used
 * to tab between (Tech Stack, Checks, Model Settings, Rules, Prompt Templates)
 * moved under /docs — the Docs home lists them ("What your AI reads") and
 * StandardsLayoutPage carries their tab strip there — so this layout no longer
 * has a tab strip of its own.
 */
export default function BuildLayoutPage() {
  return (
    <div className="p-8">
      <div className="mb-6 text-center">
        <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100 flex items-center justify-center gap-2">
          <Plug className="w-6 h-6 text-blue-600 dark:text-blue-400 shrink-0" />
          Connect
        </h1>
        <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
          Connect your AI tools to SystemDox over MCP, or export your standards as committed Agent Skills.
        </p>
      </div>

      <Outlet />
    </div>
  );
}
